import refineSearchTime from './search-time/refineSearchTime';
import refineSearchKind from './refineSearchKind/refineSearchKind';
import switchFilter from './switch-filter/switchFilter';
import resultsDirection from './results-direction/resultsDirection';

const toLoad = [
  refineSearchTime,
  refineSearchKind,
  switchFilter,
  resultsDirection
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
